import { map } from 'ramda';
import { TOPIC_CHANNEL } from "../constants/RabbitQueueEndpoints";
import { isDirectMessage } from "./ChatUtils";

/**
 * @param myArr - array of objects
 * @param prop - property field of object to make array unique by
 * @returns a Set of of unique objects without changing original order
 */
export const removeDuplicates = (myArr, prop) => {
  let localMap = myArr.map(mapObj => mapObj[prop]);
  return myArr.filter((obj, pos) => {
    return localMap.indexOf(obj[prop]) === pos;
  });
};

/**
 * Builds an ordered comma separated string of user first and last names excluding the current user.
 */
export const chatUsersToString = (users, currentUserId) => {
  let userKeys = Object.keys(users);
  //If there is more than one user, we don't want to show the current users name
  if (userKeys.length > 1) {
    userKeys = userKeys.filter(id => users[id].id !== users[currentUserId].id)
  }
  return userKeys.map(id => `${(users[id].firstName)} ${(users[id].lastName)}`.trim())
    .sort()
    .join(', '); // Add comma after each name unless its the last user
};


/** Takes in the chat user ids and retrieves their partial user information from state */
export const getUserList = (userIds, users) => map(id => users[id], userIds);

/** sort the users in chat by firstName lastName (default), or by name depending on the existence of the byName prop */
export const sortUsers = (users, byName) => {
  return users.sort((a, b) => {
    const fullNameA = byName ? a.name.toLowerCase() : `${a.firstName} ${a.lastName}`;
    const fullNameB = byName ? b.name.toLowerCase() : `${b.firstName} ${b.lastName}`;
    return fullNameA.localeCompare(fullNameB);
  });
};

export const compareUsers = (a, b) => {
  const fullNameA = `${a.firstName} ${a.lastName}`;
  const fullNameB = `${b.firstName} ${b.lastName}`;
  return fullNameA.localeCompare(fullNameB);
};

/**
 * Build topic routing keys to bind to
 * @param chats[] - the chats this user is in
 * @returns {Array} - array of amqp binding keys to subscribe to
 */
export const buildSubscriptionEndpoints = chats => {
  const endpoints = [];

  // Filter out DMs
  const channels = chats.filter(chat => !isDirectMessage(chat));

  // Build rabbit subscription keys for each channel ie: '/topic/channel.chatId'
  channels.forEach(chat => {
    endpoints.push(`${TOPIC_CHANNEL}.${chat.id}`);
  });

  return endpoints;
};